/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_BrandInputs */

const en_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const es_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const de_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const zh_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf`)
};

const ar_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const fr_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const vi_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const sw_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const th_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf`)
};

const bs_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ja_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ko_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const pt_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const it_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const sv_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const nl_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const da_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const nb_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const fi_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const pl_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ru_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const tr_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const hi_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const id_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ms_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const cs_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const el_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const he_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const af_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const hu_footer_brand = /** @type {(inputs: Footer_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

/**
* | output |
* | --- |
* | "MARK EGLY GOLF" |
*
* @param {Footer_BrandInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_brand = /** @type {((inputs?: Footer_BrandInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_BrandInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_brand(inputs)
	if (locale === "de") return de_footer_brand(inputs)
	if (locale === "zh") return zh_footer_brand(inputs)
	if (locale === "ar") return ar_footer_brand(inputs)
	if (locale === "fr") return fr_footer_brand(inputs)
	if (locale === "vi") return vi_footer_brand(inputs)
	if (locale === "sw") return sw_footer_brand(inputs)
	if (locale === "th") return th_footer_brand(inputs)
	if (locale === "bs") return bs_footer_brand(inputs)
	if (locale === "ja") return ja_footer_brand(inputs)
	if (locale === "ko") return ko_footer_brand(inputs)
	if (locale === "pt") return pt_footer_brand(inputs)
	if (locale === "it") return it_footer_brand(inputs)
	if (locale === "sv") return sv_footer_brand(inputs)
	if (locale === "nl") return nl_footer_brand(inputs)
	if (locale === "da") return da_footer_brand(inputs)
	if (locale === "nb") return nb_footer_brand(inputs)
	if (locale === "fi") return fi_footer_brand(inputs)
	if (locale === "pl") return pl_footer_brand(inputs)
	if (locale === "ru") return ru_footer_brand(inputs)
	if (locale === "tr") return tr_footer_brand(inputs)
	if (locale === "hi") return hi_footer_brand(inputs)
	if (locale === "id") return id_footer_brand(inputs)
	if (locale === "ms") return ms_footer_brand(inputs)
	if (locale === "cs") return cs_footer_brand(inputs)
	if (locale === "el") return el_footer_brand(inputs)
	if (locale === "he") return he_footer_brand(inputs)
	if (locale === "af") return af_footer_brand(inputs)
	if (locale === "hu") return hu_footer_brand(inputs)
	return en_footer_brand(inputs)
});